"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var separateWords = function (string, options) {
    if (options === void 0) { options = {}; }
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;
    return string.split(split).join(separator);
};
exports.decamelize = function (string, options) { return separateWords(string, options).toLowerCase(); };
//# sourceMappingURL=decamelize.js.map